export default __webpack_public_path__ + "static/bg-header4-7896846ac131f65427abd88219d869b1.jpg";